<template>
    <EmployeeApprovedServiceReports></EmployeeApprovedServiceReports>
</template>
<script>
    import EmployeeApprovedServiceReports from '@/components/EmployeeApprovedServiceReports.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeeApprovedServiceReports
        }
    }
</script>